import React from "react";
import Table from "../Table";

const columns = [
  {
    label: "Pokedex",
    accessor: "pokedex",
    sortable: true
  },
  {
    label: "Name",
    accessor: "name",
    sortable: true
  },
  {
    label: "Evolution",
    accessor: "evo",
    sortable: true
  },
  {
    label: "Description",
    accessor: "desc",
    sortable: true
  },
  {
    label: "Is Exclusive",
    accessor: "exclusive",
    sortable: true
  },
  {
    label: "Type(s)",
    accessor: "type",
    sortable: true
  },
  {
    label: "Is Caught",
    accessor: "isCaught",
    sortable: false
  }
];

const FirstTab = ({ data }) => {
  return (
    <div className="tab content">
      <Table caption="Paldea Pokedex" data={data} columns={columns} />
    </div>
  );
};
export default FirstTab;
